import React, { Component } from 'react';
import { Modal, Message, Form,Menu, Segment, Label, Input, Select, Radio, Button, Popup, Grid } from 'semantic-ui-react';
import CurrencyInput from 'react-currency-input';

import Rincianbp from './Rincianbp';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { messageGagal } from '../../../../../_utils/message';
import RincianList from './RincianList';
import { getOptRek2, getOptRek3, getOptRek4, getOptRek5, getOptRek6 } from '../../../../../_utils/getrekening';
import { terbilang } from '../../../../../_utils/terbilang';
import { toIDR } from '../../../../../_utils/tocurrency';
import swal from 'sweetalert';

export default class ModalEdit extends Component {

   constructor(props){
      super(props);
      this.state = {
         index_edit_now: null,
         dataSTS: props.data_edit,
         dataBPdetail: null,
         parafs: [],
         parafs_data: [],
         kuasas: [],
         rekening_banks: [],
         paraf: null,
         data: {
            rincian: [],
            paraf: "",
            nama_penyetor: "",
            alamat_penyetor: "",
            uraian: "",
            no_bukti: "",
            public_id: ""
         },
         
         data_sts:{
            kuasa_sts: props.data_edit.kuasa.id,
            paraf_sts: props.data_edit.paraf.id,
            rekening_bank_sts: props.data_edit.rekening_bank ? props.data_edit.rekening_bank.id : null,
            keterangan_sts: props.data_edit.keterangan,
            mewakili: props.data_edit.mewakili,
            is_terwakili: props.data_edit.is_terwakili,
         },

         request: true,
         loading: false,
         error: false,
         error_rinc: false,
         opt_rek_2: null,
         opt_rek_3: null,
         opt_rek_4: null,
         opt_rek_5: null,
         opt_rek_6: null,

         status_rek_2: false,
         status_rek_3: true,
         status_rek_4: true,
         status_rek_5: true,
         status_rek_6: true,

         temp: {
            manual: {
                  kd_rek_2: "",
                  kd_rek_3: "",
                  kd_rek_4: "",
                  kd_rek_5: "",
                  kd_rek_6: "",
               },
            select: {
                  kd_rek_2: "",
                  kd_rek_3: "",
                  kd_rek_4: "",
                  kd_rek_5: "",
                  kd_rek_6: "",
               },
            nilai: "",
            uraian_rinc: ""
         },

         is_manual: true,
         render_detail: false,

         status_manul: false,
         kd_rek: "",
         label_rekening: null,
         requests_label: false,
         is_edit: false,
         is_detail: false,
         kd_rek_temp: "",
         kd_rek_true: true,
         disabled_input: true,
         temp_str_kd_rek: [],

         rekening_error: false,
         is_show_form: false,
         header_message: "",
         label_rekening: null
      }

      this.onChange = this.onChange.bind(this);
      this.onChangeSTS = this.onChangeSTS.bind(this);
      this.onSubmitSTS = this.onSubmitSTS.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onChangeRek2 = this.onChangeRek2.bind(this);
      this.onChangeRek3 = this.onChangeRek3.bind(this);
      this.onChangeRek4 = this.onChangeRek4.bind(this);
      this.onChangeRek5 = this.onChangeRek5.bind(this);
      this.onChangeRek6 = this.onChangeRek6.bind(this);
      this.onSubmitRincian = this.onSubmitRincian.bind(this);
      this.onChangeNilai = this.onChangeNilai.bind(this);
      this.onToggleRadio = this.onToggleRadio.bind(this);
      this.removeRinc = this.removeRinc.bind(this);
      this.editRinc = this.editRinc.bind(this);

      this.removeBp = this.removeBp.bind(this);
      this.editBp = this.editBp.bind(this);
      this.clearData = this.clearData.bind(this);
      this.detailBp = this.detailBp.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this);
      this.onChangeMewakili = this.onChangeMewakili.bind(this);
      this.resetState = this.resetState.bind(this);

   }

   handleKeyPress(event){
      if(event.key === '/' || event.key === '%' || event.key === "'" || event.key === '"'){
         swal("Maaf, penggunaan spesial karakter (\", ', %, /) pada isian nama atau keterangan diblock", {
            icon: "warning",
         });
      }
   }

   onToggleRadio(){
      this.statusSelect(true, true, true, true);
      this.clearSelect(true, true, true, true);
      
      getOptRek2()
      .then(resRek => {
         this.setState({opt_rek_2: resRek.data});
         // this.statusSelect(true, true, true, true);
         // this.clearSelect(true, true, true, true);
      });
      this.setState({
         is_manual: !this.state.is_manual,
         label_rekening: null,
         kd_rek: "",
      });
   }

   getRekeningBankData(){
      fetch(`${BaseURLDev}/rekening_bank`, { headers })
      .then(response => {
         if(!response.ok){
            messageGagal("Load data gagal")            
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const rekening_banks = []
         resJSON.data.map((item,i)=>{
            rekening_banks.push({
               'value': item.id,
               'text': `[${item.kode_akun}] ${item.nama_akun}`,
               'key': i      
            })
            return false
         })
         this.setState({ rekening_banks: rekening_banks, rekening_banks_data: resJSON.data })
         return false
      })
   }

   getParafData(){
      fetch(`${BaseURLDev}/paraf`, { headers })
      .then(response => {
         if(!response.ok){
            messageGagal("Load data gagal")            
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const parafs = []
         resJSON.data.map((item,i)=>{
            parafs.push({
               'value': item.id,
               'text': `[${item.kode}] ${item.nama}`,
               'key': i      
            })
            return false
         })
         this.setState({ parafs: parafs, parafs_data: resJSON.data })
         return false
      })
   }

   getKuasaData(){
      fetch(`${BaseURLDev}/kuasa`, { headers })
      .then(response => {
         if(!response.ok){
            messageGagal("Load data gagal")            
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const kuasas = []
         resJSON.data.map((item,i)=>{
            kuasas.push({
               'value': item.id,
               'text': `[${item.kode}] ${item.nama}`,
               'key': i      
            })
            return false
         })
         this.setState({kuasas:kuasas})
         return false
      })
   }

   onChangeMewakili = (e) => this.setState({data_sts: {...this.state.data_sts, mewakili: {...this.state.data_sts.mewakili, [e.target.name]:e.target.value}}})
   onChangeParaf = (e, el) => this.setState({data:{...this.state.data,paraf:el.value}})
   onChangeParafSTS = (e, el) => this.setState({data_sts:{...this.state.data_sts,paraf_sts:el.value}})
   onChangeRekeningBankSTS = (e, el) => this.setState({data_sts:{...this.state.data_sts,rekening_bank_sts:el.value}})
   onChangeKuasaSTS = (e, el) => this.setState({data_sts:{...this.state.data_sts,kuasa_sts:el.value}})

   editRinc(item, index){
      
      const { rincian } = this.state.data;
      const { temp_str_kd_rek } = this.state;
      const rinciEdit = rincian[index];
      const rekening = "4."+rinciEdit.kd_rek_2+"."+rinciEdit.kd_rek_3+"."+rinciEdit.kd_rek_4+"."+rinciEdit.kd_rek_5+"."+rinciEdit.kd_rek_6;
      this.setState({
         is_manual: true,
         kd_rek: rekening,
         temp:{
            ...this.state.temp,
            nilai: rinciEdit.nilai,
            uraian_rinc: rinciEdit.uraian_rinc ? rinciEdit.uraian_rinc : "",
            manual: {
               ...this.state.temp.manual,
               kd_rek_2: rinciEdit.kd_rek_2,
               kd_rek_3: rinciEdit.kd_rek_3,
               kd_rek_4: rinciEdit.kd_rek_4,
               kd_rek_5: rinciEdit.kd_rek_5,
               kd_rek_6: rinciEdit.kd_rek_6,
            }
         }
      })

      let str_kd_rek = rincian[index].str_kd_rek;
      var index_data = null;
      for(let i=0; i<temp_str_kd_rek.length; i++) {
         if(temp_str_kd_rek[i] === str_kd_rek){
            index_data = i;
            break;
         }
      }
      const temp_str_rek_Remove = temp_str_kd_rek.slice();
      temp_str_rek_Remove.splice(index_data, 1);
      this.setState({ temp_str_kd_rek: temp_str_rek_Remove })


      const rinciRemove = rincian.slice();
      rinciRemove.splice(index, 1);
      this.setState({
         data:{
            ...this.state.data,
            rincian:rinciRemove
         }
      })
   }

   resetState(){
      this.clearSelect(true, true, true, true);
      this.statusSelect(true, true, true, true);
      this.setState({
         disabled_btn_save: false,
         loading: false,
         data: {...this.state.data,
            rincian: [],
            nama_penyetor: "",
            alamat_penyetor: "",
            uraian: "",
            paraf: null,
         },
         //parafs: null,
         temp_str_kd_rek: []
      });

      this.getParafData();
   }
   
   componentDidMount(){
      this.getParafData();
      this.getRekeningBankData();
      this.getKuasaData();
      getOptRek2()
      .then(resRek => {
         this.setState({opt_rek_2:resRek.data});
         this.statusSelect(false,false,false);
      });
      this.setState({status_rek_2:false});
   }

   componentWillMount(){
      this.getParafData();
      this.getKuasaData();
      this.getRekeningBankData();
      getOptRek2()
      .then(resRek => {
         this.setState({opt_rek_2:resRek.data});
         this.statusSelect(false,false,false);
      });
      this.setState({status_rek_2:false});
   }

   onSubmitSTS(e){
      e.preventDefault();

      const { rekening_banks } = this.state;
      const { paraf_sts, keterangan_sts, kuasa_sts, rekening_bank_sts } = this.state.data_sts;

      if(rekening_banks.length){
         if(rekening_bank_sts===null || rekening_bank_sts===""){
            swal("", 'Rekening Bank Penerima harus dipilih terlebih dahulu', "error");
            this.setState({ disabled_btn_save: false })
            return false;
         }
      }

      if(paraf_sts===null || paraf_sts===""){
         swal("", 'Pejabat/Bendahara Penerima yang menyetujui harus dipilih terlebih dahulu', "error");
         this.setState({ disabled_btn_save: false })
         return false;
      }
      
      if(kuasa_sts===null || kuasa_sts===""){
         swal("", 'Pejabat Kuasa Pengguna Anggaran (KPA) harus dipilih terlebih dahulu', "error");
         this.setState({ disabled_btn_save: false })
         return false;
      }
      
      if(keterangan_sts==="" || keterangan_sts===null){
         swal("", 'Uraian/Keterangan STS harus diisi terlebih dahulu', "error");
         this.setState({ disabled_btn_save: false })
         return false;
      }

      fetch(`${BaseURLDev}/sts/${this.state.dataSTS.public_id}`, { 
         method: 'PUT',
         body: JSON.stringify(this.state.data_sts),
         headers,
      })
      .then(response => {
         if(!response.ok){
            swal("Error", 'Update data STS gagal', "error");
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         if(!resJSON.error){
            swal("Sukses", `Update STS sukses`, "success");
         }
      })
   }
   
   onSubmit(e){
      const { paraf, rincian, nama_penyetor, alamat_penyetor, public_id, uraian, no_bukti } = this.state.data;
      const { data, index_edit_now } = this.state
      
      // console.log(paraf)
      // return false
      e.preventDefault();

      if(rincian.length < 1){
         swal("Error", `Maaf rincian rekening belum ditambahkan`, "error");
         return false;
      }

      if((paraf==="" || paraf===null)){
         swal("Error", `Beberapa data belum lengkap`, "error");
         return false;
      }else{
         this.setState({ loading: true });
         e.preventDefault();
         fetch(`${BaseURLDev}/bp/${this.state.data.public_id}`,{
            method: 'PUT',
            body: JSON.stringify(this.state.data),
            headers
         })
         .then(response => {
            if (!response.ok) { 
               swal("", "Update data BP gagal", "error");
               this.setState({ loading: false });
               return Promise.reject(response.statusText);
            }
            else{
               var index_data_paraf = null
               for(let i=0; i<this.state.parafs_data.length; i++) {
                  // console.log(`paraf = ${paraf}`)
                  // console.log(`parafs.id ${this.state.parafs[i].id}`)
                  if(this.state.parafs_data[i].id === paraf){
                     index_data_paraf = i;
                     break;
                  }
               }
               
               var data_ = Object.assign({}, this.state.dataSTS);
               data_.bp = data_.bp.slice();
               data_.bp[index_edit_now] = Object.assign({}, data_.bp[index_edit_now]);
               data_.bp[index_edit_now] = {
                  rincian: rincian,
                  paraf: this.state.parafs_data[index_data_paraf],
                  nama_penyetor: nama_penyetor,
                  alamat_penyetor: alamat_penyetor,
                  public_id: public_id,
                  uraian: uraian,
                  no_bukti: no_bukti
               }
            
               this.setState({ dataSTS: data_, is_edit: false, loading: false });
               console.log(this.state.dataSTS)
               console.log(data_)
               this.clearData();
               this.resetState()
               swal("Sukses", `Update data BP selesai`, "success");
            }
         })
      }
   }
   
   clearData(){
      this.setState({
         data: {
            ...this.state.data,
            rincian: [],
            paraf: null,
            nama_penyetor: "",
            alamat_penyetor: "",
            uraian: "",
            no_bukti: "",
            public_id: ""
         }
      })
   }
   onSubmitRincian(e){
      const { kd_rek_true, is_manual, kd_rek, data, temp_str_kd_rek } = this.state;
      const { nilai, uraian_rinc, manual, select } = this.state.temp
      const { rincian } = this.state.data;
      e.preventDefault();

      if(is_manual){
         if(this.state.kd_rek !== ""){

            const { kd_rek_2, kd_rek_3, kd_rek_4, kd_rek_5, kd_rek_6 } = manual;
            const kd_rek_123456 = `4.${kd_rek_2}.${kd_rek_3}.${kd_rek_4}.${kd_rek_5}.${kd_rek_6}`;

            if(!kd_rek_true || kd_rek_2==="" || kd_rek_3==="" || kd_rek_4==="" || kd_rek_5==="" || kd_rek_6==="" || nilai==="" || uraian_rinc===""){
               swal("", "Data rincian rekening belum lengkap", "error")
               return false;
            }else{
               if(rincian.length>0){
                  for(let i=0; i<temp_str_kd_rek.length; i++) {
                     if(temp_str_kd_rek[i] === kd_rek){
                        swal({
                           title: `Rekening ${kd_rek} sudah ada di rincian ini`,
                           text: "Apakah anda tetap melanjutkan?",
                           icon: "warning",
                           buttons: true,
                           dangerMode: true,
                        })
                        .then((will) => {
                           if (will) {
                              const newRincian = rincian.slice();
                              newRincian[i].nilai = newRincian[i].nilai+nilai;
                              newRincian[i].uraian_rinc = `${newRincian[i].uraian_rinc}, ${uraian_rinc}`;
                              this.setState({
                                 data:{
                                    ...data,
                                    rincian: newRincian
                                 },
                              });
                           }
                           this.clearRincian();
                           return false;
                        });
                        return false;
                     }
                  }
                  this.setState({
                     data:{
                        ...data,
                        rincian: [
                           ...rincian, 
                           {
                              nilai: nilai,
                              uraian_rinc: uraian_rinc,
                              kd_rek_2: kd_rek_2,
                              kd_rek_3: kd_rek_3,
                              kd_rek_4: kd_rek_4,
                              kd_rek_5: kd_rek_5,
                              kd_rek_6: kd_rek_6,
                              str_kd_rek: kd_rek_123456
                           }
                        ],
                     },
                     temp_str_kd_rek: [...this.state.temp_str_kd_rek, kd_rek_123456],
                  });
                  this.clearRincian();
                  return false;
               }
               else{
                  this.setState({
                     data:{
                        ...this.state.data,
                        rincian: [
                           ...this.state.data.rincian, 
                           {
                              nilai: nilai,
                              uraian_rinc: uraian_rinc,
                              // kd_rek_1: "4",
                              kd_rek_2: kd_rek_2,
                              kd_rek_3: kd_rek_3,
                              kd_rek_4: kd_rek_4,
                              kd_rek_5: kd_rek_5,
                              kd_rek_6: kd_rek_6,
                              str_kd_rek: kd_rek_123456,
                           }
                        ],
                     },
                     // kd_rek: "",
                     // label_rekening: null,
                     temp_str_kd_rek: [...this.state.temp_str_kd_rek, kd_rek_123456],
                  });

                  this.clearRincian();
               }
            }
         
         }else{
            swal("", "Kode rekening belum diisi", "error")
            return false
         }
      }else{
         const { kd_rek_2, kd_rek_3, kd_rek_4, kd_rek_5, kd_rek_6 } = select
         const kd_rek_123456 = `4.${kd_rek_2}.${kd_rek_3}.${kd_rek_4}.${kd_rek_5}.${kd_rek_6}`;
         
         if(!kd_rek_true || kd_rek_2==="" || kd_rek_3==="" || kd_rek_4==="" || kd_rek_5==="" || kd_rek_6==="" || nilai==="" || uraian_rinc===""){

            this.setState({error_rinc:true});
            swal("", "Data rincian rekening belum lengkap", "error")

         }else{
            if(rincian.length>0){
               for(let i=0; i<temp_str_kd_rek.length; i++) {
                  if(temp_str_kd_rek[i] === kd_rek_123456){
                     swal({
                        title: `Rekening ${kd_rek_123456} sudah ada di rincian ini`,
                        text: "Apakah anda tetap melanjutkan?",
                        icon: "warning",
                        buttons: true,
                        dangerMode: true,
                     })
                     .then((will) => {
                        if (will) {
                           const newRincian = rincian.slice();
                           newRincian[i].nilai = newRincian[i].nilai+nilai;
                           newRincian[i].uraian_rinc = `${newRincian[i].uraian_rinc}, ${uraian_rinc}`;
                           this.setState({
                              data: {
                                 ...this.state.data,
                                 rincian: newRincian
                              },
                           });
                        }
                        this.clearRincian();
                        return false;
                     });
                     return false;
                  }
               }
               this.setState({
                  data: {
                     ...data,
                     rincian: [
                        ...rincian, 
                        {
                           nilai: nilai,
                           uraian_rinc: uraian_rinc,
                           kd_rek_2: kd_rek_2,
                           kd_rek_3: kd_rek_3,
                           kd_rek_4: kd_rek_4,
                           kd_rek_5: kd_rek_5,
                           kd_rek_6: kd_rek_6,
                           str_kd_rek: kd_rek_123456,
                        }
                     ],
                  },
                  temp_str_kd_rek: [...this.state.temp_str_kd_rek, kd_rek_123456],
               });
            }else{
               this.setState({
                  data:{
                     ...data,
                     rincian: [
                        ...rincian, 
                        {
                           nilai: nilai,
                           uraian_rinc: uraian_rinc,
                           kd_rek_2: kd_rek_2,
                           kd_rek_3: kd_rek_3,
                           kd_rek_4: kd_rek_4,
                           kd_rek_5: kd_rek_5,
                           kd_rek_6: kd_rek_6,
                           str_kd_rek: kd_rek_123456,
                        }
                     ],
                  },
                  temp_str_kd_rek: [...this.state.temp_str_kd_rek, kd_rek_123456],
               });
            }               
            this.clearRincian();
         }
      }
   }

   clearRincian(){
      this.statusSelect(true, true, true, true);
      this.clearSelect(true, true, true, true);

      getOptRek2()
      .then(resRek => {
         this.setState({opt_rek_2: resRek.data});
         // this.statusSelect(true, true, true, true);
         // this.clearSelect(true, true, true, true);
      });

      this.setState({
         temp: {
            ...this.state.temp,
            manual: {
               ...this.state.temp.manual,
               kd_rek_2: "",
               kd_rek_3: "",
               kd_rek_4: "",
               kd_rek_5: "",
               kd_rek_6: "",
            },
            select: {
               ...this.state.temp.select,
               kd_rek_2: "",
               kd_rek_3: "",
               kd_rek_4: "",
               kd_rek_5: "",
               kd_rek_6: "",
            }, 
            nilai: "",
            uraian_rinc: "",
            str_kd_rek: "",
         },
         kd_rek: "",
         kd_rek_true: true,
         kd_rek_temp: "",
         label_rekening: null,
      })   
   }

   onChangeNilai = (e, maskedvalue, floatvalue) =>{
      if(this.state.is_manual && this.state.kd_rek===""){
         swal("", 'Harap isi kode rekening dahulu', "warning");
         return false;
      }else{
         this.setState({temp:{...this.state.temp,nilai:floatvalue}})
      }
   }
   onChangeSTS = (e) => {
      let text = e.target.value.replace(/['/%"]/g, '')
      this.setState({data_sts:{...this.state.data_sts, [e.target.name]:text}})    
   }  
   onChange = (e) => {
      let text = e.target.value.replace(/['/%"]/g, '')
      this.setState({data:{...this.state.data, [e.target.name]:text}})    
   }  
   statusSelect = (a, b, c, d) => this.setState({ status_rek_3: a, status_rek_4: b, status_rek_5: c, status_rek_6: d })
   
   updateStateTemp(name, value){

      const { kd_rek, temp } = this.state;
      const kd_rek_now = kd_rek==="" ? "4" : kd_rek;
      var kd_rek_23456 = null
      if(name==='kd_rek_2'){
         kd_rek_23456 = {
            kd_rek_2: value,
            kd_rek_3: "",
            kd_rek_4: "",
            kd_rek_5: "",
            kd_rek_6: "",
         }
         this.setState({
            kd_rek: `4.${value}`
         })
      }
      else if(name==='kd_rek_3'){
         kd_rek_23456 = {
            kd_rek_2: this.state.temp.select.kd_rek_2,
            kd_rek_3: value,
            kd_rek_4: "",
            kd_rek_5: "",
            kd_rek_6: "",
         }
         this.setState({
            kd_rek: `4.${this.state.temp.select.kd_rek_2}.${value}`
         })
      }
      else if(name==='kd_rek_4'){
         kd_rek_23456 = {
            kd_rek_2: this.state.temp.select.kd_rek_2,
            kd_rek_3: this.state.temp.select.kd_rek_3,
            kd_rek_4: value,
            kd_rek_5: "",
            kd_rek_6: "",
         }

         this.setState({
            kd_rek: `4.${this.state.temp.select.kd_rek_2}.${this.state.temp.select.kd_rek_3}.${value}`
         })
      }
      else if(name==='kd_rek_5'){
         kd_rek_23456 = {
            kd_rek_2: this.state.temp.select.kd_rek_2,
            kd_rek_3: this.state.temp.select.kd_rek_3,
            kd_rek_4: this.state.temp.select.kd_rek_4,
            kd_rek_5: value,
            kd_rek_6: "",
         }
         this.setState({
            kd_rek: `4.${this.state.temp.select.kd_rek_2}.${this.state.temp.select.kd_rek_3}.${this.state.temp.select.kd_rek_4}.${value}`
         })
      }
      else if(name==='kd_rek_6'){
         kd_rek_23456 = {
            kd_rek_2: this.state.temp.select.kd_rek_2,
            kd_rek_3: this.state.temp.select.kd_rek_3,
            kd_rek_4: this.state.temp.select.kd_rek_4,
            kd_rek_5: this.state.temp.select.kd_rek_5,
            kd_rek_6: value
         }
         this.setState({
            kd_rek: `4.${this.state.temp.select.kd_rek_2}.${this.state.temp.select.kd_rek_3}.${this.state.temp.select.kd_rek_4}.${this.state.temp.select.kd_rek_5}.${value}`
         })
      }

      this.setState({
         temp: {
            ...temp,
            select: kd_rek_23456
         }
      })
   }
   
   clearSelect = (a, b, c, d) => {
      if(a===true && b===true && c===true && d===true) this.setState({opt_rek_3: null, opt_rek_4: null, opt_rek_5: null, opt_rek_6: null})
      if(b===true && c===true && d===true) this.setState({opt_rek_4: null, opt_rek_5: null, opt_rek_6: null})
      if(c===true && d===true) this.setState({opt_rek_5: null, opt_rek_6: null})
      if(d===true) this.setState({opt_rek_6: null})
   }

   onChangeRek2(e, el){
      getOptRek3(el.value)
      .then(resRek => {
         this.setState({ opt_rek_3: resRek.data });
         // this.statusSelect(false,false,false,false);
      });
      this.statusSelect(false, true, true, true);
      this.clearSelect(true, true, true, true);
      this.updateStateTemp(el.name, el.value);
   }

   onChangeRek3(e, el){
      getOptRek4(this.state.temp.select.kd_rek_2, el.value)
      .then(resRek => {
         this.setState({ opt_rek_4: resRek.data });
         // this.statusSelect(false, false, false, false);
      });
      this.statusSelect(false, false, true, true);
      this.clearSelect(false, true, true, true);
      this.updateStateTemp(el.name, el.value);
   }

   onChangeRek4(e, el){
      getOptRek5(this.state.temp.select.kd_rek_2, this.state.temp.select.kd_rek_3, el.value)
      .then(resRek => {
         this.setState({ opt_rek_5: resRek.data });
         // this.statusSelect(false,false,false,true);
      });

      this.statusSelect(false, false, false, true);      
      this.clearSelect(false, false, true, true);
      this.updateStateTemp(el.name, el.value);
   }

   onChangeRek5(e, el){
      getOptRek6(this.state.temp.select.kd_rek_2, this.state.temp.select.kd_rek_3, this.state.temp.select.kd_rek_4, el.value)
      .then(resRek => {
         this.setState({ opt_rek_6: resRek.data });
         // this.statusSelect(false,false,false,false);
      });

      this.statusSelect(false, false, false, false);
      this.clearSelect(false, false, false, true); 
      this.updateStateTemp(el.name, el.value);
   }

   onChangeRek6(e, el){
      this.updateStateTemp(el.name, el.value);
      this.clearSelect(false, false, false, false);
   }

   removeRinc(item, index){
      swal({
         text: "Benar akan dihapus?",
         icon: "warning",
         buttons: true,
         dangerMode: true,
      })
      .then((willDelete) => {
         if (willDelete) {
            let { rincian } = this.state.data;
            let str_kd_rek = rincian[index].str_kd_rek;
            var rincian_str_kd_rek = [];
            for(let i=0; i<this.state.temp_str_kd_rek.length; i++) {
               if(this.state.temp_str_kd_rek[i] !== str_kd_rek){
                  rincian_str_kd_rek.push(this.state.temp_str_kd_rek[i])
               }
            }
            
            this.setState({temp_str_kd_rek: rincian_str_kd_rek})

            let rinci = rincian.slice();
            rinci.splice(index, 1);
            this.setState({ data: { ...this.state.data, rincian: rinci }});
         }
         
      });
   }

   onChangeInputRekening(e){
      const input = e.target.value;
      this.setState({
         kd_rek: input,
         requests_label: true,
         kd_rek_temp: input,
         kd_rek_true: false
      });

      var count_dot = (input.match(/\./g) || []).length

      const kd_rek = input.split(".").filter(i => i);
      const kd_rek_1 = kd_rek[0];
      const kd_rek_2 = kd_rek[1];
      const kd_rek_3 = kd_rek[2];
      const kd_rek_4 = kd_rek[3];
      const kd_rek_5 = kd_rek[4];
      const kd_rek_6 = kd_rek[5];
      
      // this.setState({
      //    temp:{
      //       ...this.state.temp,
      //       manual:{
      //          ...this.state.temp.manual,                        
      //          kd_rek_2:kd_rek_2,
      //          kd_rek_3:kd_rek_3,
      //          kd_rek_4:kd_rek_4,
      //          kd_rek_5:kd_rek_5,
      //       }
      //    },
      // })

      if(kd_rek.length === 6){
         if(kd_rek_1 === "4"){
            if(count_dot===5){
               fetch(`${BaseURLDev}/simantra/ref/searchrek6?kd_rek_1=${kd_rek_1}&kd_rek_2=${kd_rek_2}&kd_rek_3=${kd_rek_3}&kd_rek_4=${kd_rek_4}&kd_rek_5=${kd_rek_5}&kd_rek_6=${kd_rek_6}`,
                  { headers })
               .then(response => {
                     if (!response.ok) { 
                        //this.setState({requests_label:false,label_rekening:null})
                        this.setState({
                           requests_label: false,
                           kd_rek_true: false,
                           label_rekening: "Rekening kurang tepat atau periksa koneksi internet anda",
                           rekening_error: true,
                           header_message: "Ralat rekening",
                        })
                        return Promise.reject(response.statusText);
                     }else{
                        return response.json();
                     }
                  })
               .then(resJSON => {
                  this.setState({
                     requests_label: false,
                     rekening_error: false,
                     kd_rek_true: true,
                     header_message: "Rekening ditemukan",
                     label_rekening: resJSON.messages,
                     temp: {
                        ...this.state.temp,
                        manual: {
                           ...this.state.temp.manual,                        
                           kd_rek_2: kd_rek_2,
                           kd_rek_3: kd_rek_3,
                           kd_rek_4: kd_rek_4,
                           kd_rek_5: kd_rek_5,
                           kd_rek_6: kd_rek_6,
                        }

                     },
                  })
               });
            }else{
               this.setState({
                  // kd_rek:"",
                  kd_rek_true: false,
                  requests_label: false,
                  rekening_error: true,
                  header_message: "Ralat rekening",                  
                  label_rekening: `Rekening ${kd_rek} kurang tepat, mohon dikoreksi kembali`
               })
               return false;
            }
         }else{
            //this.setState({requests_label:false,label_rekening:"Harus rekening pendapatan awalan 4"})
            this.setState({
               kd_rek_true: false,
               rekening_error: true,
               header_message: "Ralat rekening",
               requests_label: false,
               label_rekening: "Harus rekening pendapatan yang berawalan 4"
            })
         }
      }else{
         if(kd_rek.length === 0){
            this.setState({
               requests_label: false,
               label_rekening: null,
               rekening_error: true
            })                        
         }else if(kd_rek.length < 6){
            this.setState({
               requests_label: false,
               label_rekening: null,
               rekening_error: true
            })            
         }else if(kd_rek.length > 6){
            this.setState({
               requests_label: false,
               label_rekening: null,
               rekening_error: true
            })                        
         }
      }
   }

   editBp(item, index){
      let { bp } = this.state.dataSTS;
      let data_ = bp[index];

      var str_kd_rek = []
      for(let i=0; i<data_.rincian.length;i++){
         str_kd_rek.push(data_.rincian[i].str_kd_rek)
      }

      this.setState({
         data: {
            ...this.state.data,
            rincian: data_.rincian,
            paraf: data_.paraf.id,
            nama_penyetor: data_.nama_penyetor,
            alamat_penyetor: data_.alamat_penyetor,
            no_bukti: data_.no_bukti,
            uraian: data_.uraian,
            // id:data_.bp.id,
            // is_active:data_.bp.is_active,
            public_id: data_.public_id,

         },
         paraf: data_.paraf.id,
         index_edit_now: index,
         is_edit: true,
         is_detail: false,
         temp_str_kd_rek: str_kd_rek,
         is_show_form: true
      })
   }

   removeBp(item, index){
      fetch(`${BaseURLDev}/bp/${item.public_id}`,{
         headers,
         method: 'DELETE'
      })
      .then(response => {
         if (!response.ok) { 
            swal("", "Delete data BP gagal", "error")
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(parsedJSON => {
         let { bp } = this.state.dataSTS
         let bp_ = bp.slice();
         bp_.splice(index, 1);
         this.setState({
            dataSTS:{
               ...this.state.dataSTS,
               bp:bp_
            }
         });
      })
      
   }

   detailBp(item, index){
      let { bp } = this.state.dataSTS
      let bp_ = bp.slice();

      this.setState({
         dataBPdetail: bp_[index],
         is_detail: true,
         is_show_form: false
      })
   }

   handleChange = (e, { value }) => this.setState({ value })

   render() {
      const styletb = {
         borderCollapse: 'collapse',
         borderSpacing: 0,
         borderStyle: 'solid',
         width: '100%',
      }
      const { nama_penyetor, alamat_penyetor, uraian, rincian, paraf } = this.state.data;
      const { loading, kd_rek, rekening_banks } = this.state;
      const { paraf_sts, rekening_bank_sts, kuasa_sts, keterangan_sts } = this.state.data_sts;
      const { nilai, uraian_rinc} = this.state.temp
      
      var count = 0;
      var counter = 0;

      if(rincian.length !== 0){
         rincian.map(function(item, i){
            count=count+item.nilai
            counter=counter+(i+1)
         })
      }

      return (
         
         <div>
            <Modal trigger={<Button>Show Modal</Button>} closeIcon
                  open={this.props.open}
                  onClose={this.props.onClose}
                  closeOnEscape={false}
                  closeOnRootNodeClick={false}
                  size="fullscreen"
               >
               <Modal.Header>
                  Edit data dengan nomor [{this.state.dataSTS.no_sts}]
               </Modal.Header>
               
               <Modal.Content scrolling>
                  <Grid>
                     <Grid.Column width={6}> 
                        <h4>Pilih salah satu BP yang akan diedit</h4>
                        <Rincianbp 
                           editBp={this.editBp} 
                           removeBp={this.removeBp}
                           detailBp={this.detailBp} 
                           data={this.state.dataSTS} 
                        />
                        <Segment padded>
                           <Label attached='top' color="violet">Form edit STS</Label>                        
                           <Form onSubmit={this.onSubmitSTS} loading={this.state.loading}>
                           {rekening_banks.length ?
                              <span>
                                 <Label>Rekening Bank Penerima</Label> 
                                 <Form.Dropdown 
                                    control={Select} search 
                                    onChange={this.onChangeRekeningBankSTS} 
                                    options={this.state.rekening_banks} 
                                    name="rekening_bank_sts" 
                                    defaultValue={rekening_bank_sts}
                                    placeholder='Pilih Rekening Bank Penerima'
                                    title='Pilih Rekening Bank Penerima' 
                                 /><br />
                              </span>
                              : ""
                           }
                              <Label>Bendahara Penerima</Label> 
                              <Form.Dropdown 
                                 control={Select} search 
                                 onChange={this.onChangeParafSTS} 
                                 options={this.state.parafs} 
                                 name="paraf_sts" 
                                 defaultValue={paraf_sts}
                                 placeholder='Pilih pejabat/pegawai penyetujui'
                                 title='Pilih pejabat/pegawai penyetujui' 
                              />
                              <Label>Pejabat (KPA) Kuasa Pengguna Anggaran</Label> 
                              <Form.Dropdown 
                                 control={Select} search 
                                 onChange={this.onChangeKuasaSTS} 
                                 options={this.state.kuasas}
                                 defaultValue={kuasa_sts} 
                                 name="kuasa_sts"
                                 placeholder='Pilih kuasa pengguna anggaran'
                                 title='Pilih kuasa pengguna anggaran' 
                              />
                              {this.state.data_sts.is_terwakili ?
                                 <span>
                                    <Label>Data Pejabat Mewakili</Label><br />
                                    <Form.Input value={this.state.data_sts.mewakili.nama_mewakili} onChange={this.onChangeMewakili}
                                       name="nama_mewakili" placeholder='Nama Pejabat Mewakili'
                                       title='Nama Pejabat Mewakili' />
                                 
                                    {/* <Label>NIP Pejabat Mewakili</Label> */}
                                    <Form.Input value={this.state.data_sts.mewakili.nip_mewakili} onChange={this.onChangeMewakili}
                                       name="nip_mewakili" placeholder='NIP Pejabat Mewakili'
                                       title='NIP Pejabat Mewakili' />
                                    {/* <Label>Jabatan Pejabat Mewakili</Label> */}
                                    <Form.Input value={this.state.data_sts.mewakili.jabatan_mewakili} onChange={this.onChangeMewakili}
                                       name="jabatan_mewakili" placeholder='Jabatan Pejabat Mewakili'
                                       title='Jabatan Pejabat Mewakili' /><br />
                                 </span>
                              : ""
                              }
                              <Form.TextArea 
                                 style={{'height': '150px'}} 
                                 value={keterangan_sts} 
                                 onChange={this.onChangeSTS} 
                                 onKeyPress={this.handleKeyPress}
                                 placeholder='Keterangan STS'
                                 title='Keterangan STS' name="keterangan_sts" 
                              />

                              <Form.Button size='medium' positive>Perbaharui STS</Form.Button>
                           
                           </Form>
                        </Segment> 
                     </Grid.Column>         
                     <Grid.Column width={10}>  
                        <Segment color="violet">
                        {this.state.is_detail ? 
                           <div id="data_print">
                              <table align="center" width="100%" style={{fontSize:'14px'}}>
                                 <tbody>
                                    <tr align="center">
                                       <th colSpan="2">
                                          <p style={{fontSize:'18px',marginBottom: '25px'}}>
                                          SETORAN BUKTI PENERIMAAN (BP)</p>
                                       </th>
                                    </tr>
                                    <tr>
                                       <td width="30%">Nomor BP</td>
                                       <td>&nbsp;:&nbsp;{this.state.dataBPdetail.no_bukti}</td>
                                    </tr>
                                    <tr>
                                       <td width="30%">Penyetor</td>
                                       <td>&nbsp;:&nbsp;{this.state.dataBPdetail.nama_penyetor}</td>
                                    </tr>
                                    
                                    <tr>
                                       <td colSpan="2"><i>Dengan rincian penerimaan sebagai berikut</i> :</td>
                                    </tr>
                                 </tbody>
                              </table>
                              <table border="1" align="center" style={styletb}>
                                 <tbody>            
                                    <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                       <th width="5%" style={{padding:'4px'}}>No.</th>
                                       <th width="15%" style={{padding:'4px'}}>Rekening</th>
                                       <th width="60%" style={{padding:'4px'}}>Uraian</th>
                                       <th width="25%" style={{padding:'4px'}} align="right">Jumlah (Rp.)</th>
                                    </tr>
                                    {
                                       this.state.dataBPdetail.rincian.map((rek,i)=>{
                                          counter = counter + 1
                                          return (<tr key={counter}>
                                             <td style={{padding:'4px'}} width="5%">{counter}.</td>
                                             <td style={{padding:'4px'}} width="15%">{`${rek.kd_rek_1}.${rek.kd_rek_2}.${rek.kd_rek_3}.${rek.kd_rek_4}.${rek.kd_rek_5}`}</td>
                                             <td style={{padding:'4px'}} width="60%">{rek.uraian_rinc}</td>
                                             <td style={{padding:'4px'}} width="25%" align="right">{ toIDR(rek.nilai)}</td>
                                          </tr>)
                                       })
                                    }
                                    <tr style={{background:'#e5e5e5'}}>
                                       <td style={{padding:'4px'}} colSpan="4" align="right">
                                          { toIDR(count) }
                                       </td>
                                    </tr>
                                    <tr>
                                       <td style={{padding:'4px'}} colSpan="4" align="right">
                                          <i>{terbilang(count)}</i>
                                       </td>
                                    </tr>
                                 </tbody>            
                              </table>
                           </div>   
                        : "" }
                        {this.state.is_show_form ? 
                        <span><Grid>
                           <Grid.Column width={8}>
                           <Segment>
                           {/*start of rincian=====================================================================================================*/}            
                              <Popup
                                 trigger={
                                    <Radio toggle style={{marginBottom:'10px'}}
                                       onChange={this.onToggleRadio}/> 
                                 }
                                 header="Toggle Rekening"
                                 content='Manual input atau memilih list'
                                 on='hover'
                                 inverted
                              />
                              {this.state.label_rekening!==null && 
                                 <Message
                                    error={this.state.rekening_error}
                                    success={!this.state.rekening_error}
                                    header={this.state.header_message}
                                    content={this.state.label_rekening}
                                 />
                                 /*<Label color='red' pointing='below'>{this.state.label_rekening}</Label>*/
                              }
                              <Form error={true} disabled={!this.state.is_edit} loading={loading}>
                                 {this.state.is_manual ?
                                    <Form.Field>
                                       {/*
                                          this.state.requests_label ? <Loader active inline='centered' /> :
                                          this.state.label_rekening!==null && <Label color='red' pointing='below'>{this.state.label_rekening}</Label>
                                       */}
                                       <Input 
                                          loading={this.state.requests_label}
                                          value={kd_rek}
                                          autoFocus
                                          icon='credit card' 
                                          autoComplete="off"
                                          onChange={(e)=>this.onChangeInputRekening(e)} 
                                          name="kd_rek"
                                          placeholder="contoh 4.1.1.1.1"   
                                       />
                                    </Form.Field>
                                    :
                                    <div style={{marginBottom:'5px'}}>
                                       <Form.Field>
                                          <Input 
                                             disabled={true}
                                             placeholder='[4] PENDAPATAN'
                                          />
                                       </Form.Field>
                                       <Popup
                                          trigger={
                                             <Form.Field search control={Select} //loading={this.state.status_rek_2} 
                                             disabled={this.state.status_rek_2}
                                             onChange={this.onChangeRek2} 
                                             options={this.state.opt_rek_2} name="kd_rek_2" 
                                             placeholder='Pilih rekening ke 2' />}
                                          content='Pilih rekening ke 2'
                                          on='hover'
                                          inverted
                                       />
                                       <Popup
                                          trigger={
                                             <Form.Field search //loading={this.state.status_rek_3} 
                                          disabled={this.state.status_rek_3}
                                          control={Select} onChange={this.onChangeRek3} 
                                          options={this.state.opt_rek_3} name="kd_rek_3" 
                                          placeholder='Pilih rekening ke 3' />}
                                          content='Pilih rekening ke 3'
                                          on='hover'
                                          inverted
                                       />
                                   
                                       <Popup
                                          trigger={
                                             <Form.Field search control={Select} //loading={this.state.status_rek_4} 
                                                disabled={this.state.status_rek_4}
                                                onChange={this.onChangeRek4} 
                                                options={this.state.opt_rek_4} name="kd_rek_4" 
                                                placeholder='Pilih rekening ke 4' />}
                                          content='Pilih rekening ke 4'
                                          on='hover'
                                          inverted
                                       />             
                                       <Popup
                                          trigger={
                                             <Form.Field search control={Select} //loading={this.state.status_rek_5} 
                                             disabled={this.state.status_rek_5}
                                             onChange={this.onChangeRek5} 
                                             options={this.state.opt_rek_5} name="kd_rek_5" 
                                             placeholder='Pilih rekening ke 5' />}
                                          content='Pilih rekening ke 5'
                                          on='hover'
                                          inverted
                                       />

                                       <Popup
                                          trigger={
                                             <Form.Field search control={Select} //loading={this.state.status_rek_6} 
                                             disabled={this.state.status_rek_6}
                                             onChange={this.onChangeRek6} 
                                             options={this.state.opt_rek_6} name="kd_rek_6" 
                                             placeholder='Pilih rekening ke 6' />}
                                          content='Pilih rekening ke 6'
                                          on='hover'
                                          inverted
                                       /> 
                                       
                                    </div> 
                                 }
                                 <Popup
                                    trigger={
                                       <CurrencyInput autoComplete="off" decimalSeparator="," precision="2" value={nilai} 
                                          thousandSeparator="."
                                          onChangeEvent={this.onChangeNilai} name="nilai" />}
                                    content='Nilai yang disetor'
                                    on='focus'
                                    inverted
                                 />
                                    <Form.TextArea style={{marginTop:'10px'}} value={uraian_rinc} 
                                       onChange={(e) => {
                                          let text = e.target.value.replace(/['/%"]/g, '')
                                          this.setState({temp:{...this.state.temp,uraian_rinc:text}})} 
                                       }
                                       onKeyPress={this.handleKeyPress}
                                       placeholder='Untuk pembayaran ...'
                                       ttile='Untuk pembayaran ...' name="uraian_rinc" />
               
                                 <Button.Group size='mini' style={{marginTop:'15px'}}>
                                    <Button 
                                       label={{ basic: true, color: 'red', pointing: 'left', content: toIDR(count) }}
                                       color="blue" 
                                       onClick={this.onSubmitRincian}
                                       content="Tambah rincian"
                                       disabled={!this.state.is_edit}
                                    />
                                 </Button.Group>
                              </Form><br /><br />
                              {
                                 rincian.length!==0 &&
                                 <RincianList rincian={rincian} edit={this.editRinc} removeRinc={this.removeRinc}/>
                              }
                           </Segment>
                        </Grid.Column>
                     {/*end of rincian=====================================================================================================*/}
                        <Grid.Column width={8}>   
                                
                     {/*start of data pelengkap=====================================================================================================*/}
                     <Segment>
                                             
                        <Form disabled={!this.state.is_edit} loading={this.state.loading}>
                           <Form.Dropdown 
                              control={Select} 
                              search
                              onChange={this.onChangeParaf} 
                              options={this.state.parafs} 
                              name="paraf" 
                              defaultValue={paraf}
                              placeholder='Pilih pejabat/pegawai'
                              title="Pilih pejabat/pegawai" />

                              <Form.Input value={nama_penyetor} onChange={this.onChange} onKeyPress={this.handleKeyPress}
                                 name="nama_penyetor" placeholder='Nama penyetor'
                                 title='Nama penyetor' />               
               
                              <Form.TextArea value={alamat_penyetor} onChange={this.onChange} onKeyPress={this.handleKeyPress}
                                 placeholder='Alamat penyetor' title='Alamat penyetor' name="alamat_penyetor" />
               
                              <Form.TextArea value={uraian} onChange={this.onChange} onKeyPress={this.handleKeyPress}
                              placeholder='Keterangan BP boleh dikosongkan' name="uraian" 
                              title='Keterangan BP boleh dikosongkan' />
               
                              {/*<Form.Button size='medium' disabled={!this.state.is_edit}>Update data</Form.Button>*/}
                           </Form>
                           <Message
                              error
                              header='** Penting'
                              content='Uraian pembayaran dan keterangan harus diisi'
                           />
                        </Segment>
                        </Grid.Column>
                     </Grid>
                        <Menu>
                           <Menu.Item>
                              <Button 
                                 disabled={!this.state.is_edit}
                                 onClick={this.onSubmit} 
                                 positive size='medium' 
                                 content="Perbaharui Data BP" 
                                 icon="save" 
                              />&nbsp;&nbsp;
                              {/*<Button 
                                 // disabled={!is_enabled_reset}
                                 onClick={this.onReset} 
                                 negative 
                                 size='medium' 
                                 icon="trash" 
                                 content="Reset semua data" 
                              />*/}
                           </Menu.Item>
                        </Menu></span>
                     : "" }
                     </Segment>
                     </Grid.Column>         
                  </Grid>
               </Modal.Content>
               
               <Modal.Actions>
                  <Button style={{'float': 'left'}} negative onClick={this.props.onClose}>Tutup</Button>
                  <Button negative onClick={this.props.onClose}>Tutup</Button>
               </Modal.Actions>
            </Modal>            
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_sts/ModalEdit.js